<template>
    <div class="account">
      <heads ></heads>
      <div class="account-center">
        <table>
          <tr><td>{{$t('account.sn')}}</td><!--<td>{{$t('account.abbr')}}</td>--><td>{{$t('account.beforeAccount')}}</td><td>{{$t('account.amount')}}</td><td>{{$t('account.afterAccount')}}</td><td>{{$t('account.type')}}</td><td>{{$t('account.time')}}</td></tr>
          <tr v-for="item in list"><td>{{item.order_id}}</td><!--<td>{{item.platform}}</td>--><td>{{parseFloat(item.before_balance)}}</td><td><span v-if="item.is_modified===0" style="color: #ff0000">+{{parseFloat(item.amount)}}</span><span v-else style="color: #55a532">-{{parseFloat(item.amount)}}</span></td><td>{{parseFloat(item.balance)}}</td><td>{{item.describe}}</td><td>{{item.created_at}}</td></tr>
        </table>
        <div class="pagetation_info clearfix">
          <ul class="pagetation_box">
            <li class="firstPage" @click="page.currentPage-- && _gotoPage(1)"><a href="javascript:;">{{$t('account.homePage')}}</a></li>
            <li class="prev" v-show="page.currentPage != 1" @click="page.currentPage-- && _gotoPage(page.currentPage)"><a href="javascript:;">&lt;</a></li>
            <li v-for="index in pages" @click="_gotoPage(index)" :class="{'active':page.currentPage == index}"><a href="javascript:;">{{index}}</a></li>
            <li class="next" v-show="page.allPages != page.currentPage && page.allPages != 0 " @click="page.currentPage++ && _gotoPage(page.currentPage)"><a href="javascript:;">&gt;</a></li>
            <li class="lastPage"  @click="page.currentPage-- && _gotoPage(page.allPages)"><a href="javascript:;">{{$t('account.lastPage')}}</a></li>
          </ul>
          <div class="num_total">
            {{$t('account.total')}} <span>{{page.allRecords}}</span> {{$t('account.info')}}，{{$t('account.total')}} <span>{{page.allPages}}</span> {{$t('account.page')}}
          </div>
        </div>
      </div>
    </div>
</template>

<script>
  import heads from '../navs/headr'
    export default {
        name: "account",
      components:{heads},
      data(){
          return{
            username:'',
            balance:"",
            phone:'',
            withdraw_bet_quota:'',
            isToken:'',
            list:[],
            "page":{
              "currentPage":1,
              "pagesize":10,
              "allRecords":0,
              "allPages":0,
              "showItem":4,
            },
            ispage:false,
            isOrder:false,
          }
      },
      computed:{
        pages:function(){/*显示页码*/
          let _this=this;
          let p=[];

          if( _this.page.currentPage < _this.page.showItem ){
            let i = Math.min(_this.page.showItem,_this.page.allPages);
            while(i){
              p.unshift(i--);
            }
          }else{
            let middle = _this.page.currentPage - Math.floor(_this.page.showItem / 2 ),
              i = _this.page.showItem;
            /* console.log(middle,i)*/;
            if( middle > (_this.page.allPages - _this.page.showItem) ){
              middle = (_this.page.allPages - _this.page.showItem) + 1
            }
            while(i--){
              p.push( middle++ );
            }
          }
          return p;
        },
      },
      created:function(){
          let _self=this;
          _self._change(1);
      },
      methods:{
        _change:function (page) {
          let _self=this;
          this._PublicFun.getData('2','get', 'change/list?page='+page+'&type=1,2,10,11,16,21,22', {}, function (result) {
            if(result.data['status_code']==200){
              if(result.data['meta'].current_page==1){
                _self.list=[];
              }
              if(result.data['data'].length>0){
                _self.list=result.data['data'];
                _self.page.allRecords=result.data['meta'].total;
                _self.page.allPages=result.data['meta'].last_page;
                if(result.data['meta'].last_page>1){
                  _self.ispage=true;
                }else{
                  _self.ispage=false;
                }
                _self.isOrder=false;
              }else{
                Toast(_self.$t('account.noData'));
                _self.isOrder=false;
              }
            }

          })
        },
        _gotoPage:function(i){
          let _this=this;
          if(_this.isOrder)
            return false;
          _this.isOrder=true;
          _this._change(i);
          if(i == _this.page.currentPage) return;
          _this.page.currentPage = i;
        },
      }
    }
</script>

<style scoped>
  @import "../../assets/css/page.css";
  .account{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    bottom: 0;
    background-color: #ffffff;

  }
  .account-center{
    position: absolute;
    top: 45px;
    left: 0;
    width: 100%;
    bottom: 0;
    overflow-y: auto;
  }
  .account-center table{
    width: 100%;
    border: 1px solid #dcdcdc;
    text-align: center;
    border-collapse:collapse;
  }
  .account-center table tr{
    border-bottom: 1px solid #dcdcdc;
  }
  .account-center table tr td{
    padding: 10px 0;
    border-right: 1px solid #dcdcdc;
  }
  .account-center table tr td:last-child{
    border-right: none;
  }
  .account-center table tr td select{
    padding: 5px 10px;
    border-radius: 5px;
    outline: none;
    font-weight: bold;
    font-size: 18px;
  }
</style>



// WEBPACK FOOTER //
// src/components/user/account.vue